import {
  FETCH_RUPTURE_REQUEST,
  FETCH_RUPTURE_SUCCESS,
  FETCH_RUPTURE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  record: {},
  error: null,
  isFetching: false,
  filters: {},
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_RUPTURE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_RUPTURE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        record: action.payload,
        filters: action.filters,
      }

    case FETCH_RUPTURE_ERROR:
      return {
        ...state,
        isFetching: false,
        record: {},
        error: action.payload,
        filters: action.filters,
      }

    default:
      return state
  }
}

export default record
